import { useDispatch } from "src/store";
import { makeStyles } from "tss-react/mui";

import { showDetails } from "@dashboard/devices/store";
import { Box } from "@mui/material";
import { ActivityIcon } from "@shared/Loading";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";

import { Rollout } from "../../types";
import { rolloutStatusLabel } from "../../utils/rolloutStatus";

const useStyles = makeStyles()((theme) => ({
    content: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
}));

type Props = {
    id: number;
    status: Rollout["status"];
};

export const RolloutStatusCell = ({ id, status }: Props) => {
    const dispatch = useDispatch();
    const { classes } = useStyles();

    const onRollout = () => {
        dispatch(showDetails({ type: "rollout", selectedId: id }));
    };

    return (
        <MinimalTableCell onClick={onRollout}>
            <Box className={classes.content}>
                {status === "active" ? <ActivityIcon /> : null}
                {rolloutStatusLabel[status]?.() ?? status}
            </Box>
        </MinimalTableCell>
    );
};
